/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FiberTracingTab } from '@/app/(client)/transactions/-components/FiberTracingTab';
import { PageContainer } from '@/components/shared/PageContainer';
import { PageHeader } from '@/components/shared/PageHeader';
import { Skeleton } from '@/components/ui/skeleton';
import { useLotTracing } from '../../../../../-hooks/useLotTracing';

const searchSchema = z.object({
  lotName: z.string().optional(),
});

export const Route = createFileRoute(
  '/(client)/inventory/(pages)/(detail)/lots/$lotId/tracing/',
)({
  validateSearch: searchSchema,
  component: LotTracingPage,
});

function LotTracingPage() {
  const { lotId } = Route.useParams();
  const { lotName } = Route.useSearch();
  const { data: tracing, isLoading } = useLotTracing(lotId);

  if (isLoading) {
    return (
      <div className='flex flex-col gap-4 p-4'>
        <Skeleton className='h-8 w-40' />
        <Skeleton className='w-full rounded-xl h-[calc(100vh-340px)] min-h-100' />
      </div>
    );
  }

  if (!tracing) return null;

  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-hidden'>
      <PageHeader>
        <h1 className='text-lg font-semibold'>{lotName ?? lotId}</h1>
      </PageHeader>
      <PageContainer className='h-full'>
        <div className='h-full flex-1 min-h-0'>
          <FiberTracingTab tracing={tracing} />
        </div>
      </PageContainer>
    </div>
  );
}
